import React, { useEffect, useState } from "react";
import apiURL from "../../store/actions/apiURL";
import { connect } from 'react-redux';
import Select from 'react-select';
import { Actions as REPORTACTIONS } from '../../store/actions/reportActions';
import { Actions as PAYPERIODACTIONS } from '../../store/actions/payPeriodActions';
import { XMarkIcon, ArrowDownTrayIcon } from '@heroicons/react/20/solid';
import Spinner from "../../components/common/Spinner";
import _ from 'lodash';
import cleanDeep from "clean-deep";
import { format } from 'date-fns';


const ReportPayPeriodModal = ({
    openReport,
    showReportPayPeriodModal,
    payPeriods,
    startDate,
    endDate,
    checkGroupBy,
    totalsOnly,
    departmentFilter,
    reports,
    getPayPeriods,
}) => {

    const [payPeriod, setPayPeriod] = useState(payPeriods?.[0]);

    const [report, setReport] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setReport(reports.find(r => r.id == openReport));
    }, [openReport]);

    useEffect(() => {
        if (!payPeriods.length) getPayPeriods();
    }, []);

    useEffect(() => {
        setPayPeriod(payPeriods[0]);
    }, [payPeriods]);

    if (!openReport) return null;

    const onClick = () => {

        const qs = new URLSearchParams(cleanDeep({ start: format(startDate, "yyyy-MM-dd"), end: format(endDate, "yyyy-MM-dd"), group: checkGroupBy, totals: totalsOnly, department: departmentFilter, companyPayPeriod: payPeriod?.value }));

        setLoading(true);
        fetch(`${apiURL}${report.path ? report.path : `/report/get/${report.id}`}?${qs}`, {
            credentials: 'include',
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                /*'Organisation': getState().currentOrganisation,*/
            },
        })
            .then(response => response.json())
            .then(data => {
                console.log({ popup: data.signedURL });
                const popup = window.open(data.signedURL);
                if (!popup || popup.closed || typeof popup.closed == 'undefined') {
                    //Worked For IE and Firefox
                    alert("Popup Blocker is enabled! Please add this site to your exception list.");
                }
                setLoading(false);
                showReportPayPeriodModal(false);
            })
    }

    return (
        <div className="modal" tabIndex="-1" role="dialog" aria-hidden="true" style={{ overflow: "auto", display: "block", background: "rgba(0,0,0,0.4)" }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="block block-themed block-transparent remove-margin-b" style={{ padding: 0 }}>
                        <div className="block-header bg-primary-dark" style={{ padding: 20 }}>
                            <ul className="block-options">
                                <li>
                                    <button type="button" onClick={() => showReportPayPeriodModal(false)}>
                                        <XMarkIcon className="h-6 w-6 mr-3 text-white" />
                                    </button>
                                </li>
                            </ul>
                            <h3 className="block-title">Select a Pay Period</h3>
                        </div>
                        <div className="block-content" style={{ padding: 20, paddingBottom: 15 }}>
                            <Select
                                value={payPeriod}
                                options={payPeriods}
                                onChange={setPayPeriod}
                            />
                            <div className="btn btn-success" onClick={onClick} style={{ marginTop: 10, float: "right" }}>
                                {loading ? <Spinner style={{ marginRight: 10, verticalAlign: 'text-bottom' }} className="animate-spin -ml-1 mr-3 h-7 w-7" /> : <ArrowDownTrayIcon className='w-6 h-6 mr-3' style={{ verticalAlign: "text-bottom" }} />}
                                Download Report
                            </div>
                            <div className="clearfix" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {

    return {
        openReport: state.report.payPeriodModalStatus,
        payPeriods: (state?.payPeriods?.periods && _.orderBy(state.payPeriods.periods, ['periodEnd'], ['desc']).map(p => ({ label: `${state?.company?.settings?.paySchedules?.find(ps => ps.id == p.paySchedule)?.name ? state?.company?.settings?.paySchedules?.find(ps => ps.id == p.paySchedule)?.name : "Pay"} ${p?.period}, ${p?.year} (${format(new Date(p?.periodStart), "do MMM yyyy")} to ${format(new Date(p?.periodEnd), "do MMM yyyy")})`, value: p.id }))) || [],
    }
}

const mapDispatchToProps = dispatch => ({
    showReportPayPeriodModal: (status) => dispatch(REPORTACTIONS.showReportPayPeriodModal(status)),
    getPayPeriods: () => dispatch(PAYPERIODACTIONS.getPayPeriods()),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ReportPayPeriodModal)